import { IHistoryManagerInjectable } from '@src/slide/application/service/history-manager/core/history-manager.interface';
import { isClientDriveFile } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';
import appConfigInstance, { setDefaultConfig } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';

export class HistoryManagerInjectable implements IHistoryManagerInjectable {
    public get isSupportArkVersionManager() {
        return !isClientDriveFile();
    }

    public get enableHistoryVersion() {
        return setDefaultConfig(appConfigInstance.getConfig('custom.feature.history.version' as any), true);
    }

    public onBeforeRevertUrlReload(): boolean {
        return false;
    }

    // 分片加载完成之后，版本及编辑记录相关的刷新网页需要删除 notAlreadyCreate 参数, 不然文档中台会报错。
    public deleteSearchParamNotAlreadyCreate() {
        try {
            const urlObj = new URL(location.href);
            urlObj.searchParams.delete('notAlreadyCreate');
            history.replaceState({}, '', urlObj.toString());
        } catch (error) {
            console.log('deleteSearchParamNotAlreadyCreate error:', error);
        }
    }
}
